var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "documents-tab" },
    [
      _vm.isMy
        ? [
            _c("div", { staticClass: "update-doc" }, [
              _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "text_large" }, [
                  _vm._v(_vm._s(_vm.i18n.sale_tab_documents_ismy_header()))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text_small text_description text_margin" },
                  [_vm._v(_vm._s(_vm.i18n.sale_tab_documents_ismy_text()))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text_small text_description text_margin" },
                  [_vm._v(_vm._s(_vm.i18n.divid_save_report()))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text_small text_description text_margin" },
                  [_vm._v(_vm._s(_vm.i18n.lbl_pdf_5mb()))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text_small text_description text_margin" },
                  [
                    _c("file-field", {
                      attrs: {
                        accept: ".pdf",
                        checkType: true,
                        id: "documents-tab__file-field"
                      },
                      model: {
                        value: _vm.upload,
                        callback: function($$v) {
                          _vm.upload = $$v
                        },
                        expression: "upload"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _vm.upload.file
              ? _c(
                  "md-button",
                  {
                    staticClass: "btn md-primary",
                    attrs: { disabled: _vm.isPending },
                    on: { click: _vm.submit }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.i18n.lbl_publish_file()) +
                        "\n    "
                    )
                  ]
                )
              : _vm._e()
          ]
        : !_vm.documents.length && !_vm.isMy
        ? [
            _c("div", { staticClass: "empty-timeline-message" }, [
              _c("div", { staticClass: "text_large" }, [
                _vm._v(_vm._s(_vm.i18n.sale_doc_tab_docs_is_my()))
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.documents.length
        ? _c(
            "div",
            { staticClass: "documents-tab__docs-list" },
            [
              _vm._l(_vm.documents, function(document, i) {
                return [
                  _c(
                    "div",
                    { key: i, staticClass: "documents-tab__file-download-wrp" },
                    [
                      _c(
                        "h3",
                        {
                          staticClass: "file-download__file-name",
                          attrs: { title: document.name }
                        },
                        [_vm._v(_vm._s(document.name))]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "file-view__link",
                          attrs: {
                            href: _vm.getUrl(document),
                            target: "_blank",
                            rel: "noopener"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.i18n.fi_view_file()))])]
                      )
                    ]
                  )
                ]
              })
            ],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-abc50cc4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abc50cc4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/tabs/Sales.DocumentsTab.vue
// module id = fMn7
// module chunks = 1